import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'
import { AppContainer } from '~/components/new/app-ui/app-container'
import { AppHeader } from '~/components/new/app-ui/app-header'
import { Title } from '~/components/new/app-ui/title'
import { PlatformStockDeclarationDialog } from '~/components/routes/platform-stocks/declaration/platform-stock-declaration-dialog'
import { PlatformStockBulkDialog } from '~/components/routes/platform-stocks/platform-stock-bulk-dialog'
import { PlatformStockFilters } from '~/components/routes/platform-stocks/platform-stock-filters'
import { PlatformStockTable } from '~/components/routes/platform-stocks/stock/platform-stock-table'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/platform-stocks/')({
  staticData: {
    permission: ['read', 'platform-stocks'],
  },
  component: PlatformStocksPage,
  validateSearch: z.object({
    storeReference: z.string().optional(),
    categoryIds: z.array(z.number()).optional(),
    search: z.string().optional(),
    lot: z.string().optional(),
    page: z.number().optional(),
    pageSize: z.number().optional(),
  }),
})
withRoutePermissions(Route)

function PlatformStocksPage() {
  const navigate = Route.useNavigate()
  const {
    storeReference,
    categoryIds = [],
    search = '',
    lot = '',
    page = 1,
    pageSize = 10,
  } = Route.useSearch()

  return (
    <>
      <AppHeader>
        <Title>Stock Plateforme</Title>
      </AppHeader>

      <AppContainer>
        <div className="flex items-start justify-between gap-4">
          <PlatformStockFilters
            storeReference={storeReference}
            categoryIds={categoryIds}
            search={search}
            lot={lot}
            onStoreChange={(v) =>
              navigate({
                search: (prev) => ({ ...prev, storeReference: v ?? undefined, page: undefined }),
              })
            }
            onCategoryChange={(ids) =>
              navigate({
                search: (prev) => ({
                  ...prev,
                  categoryIds: ids.length ? ids : undefined,
                  page: undefined,
                }),
              })
            }
            onProductChange={(v) =>
              navigate({
                search: (prev) => ({
                  ...prev,
                  search: v ?? undefined,
                  lot: undefined,
                  page: undefined,
                }),
              })
            }
            onLotChange={(v) =>
              navigate({
                search: (prev) => ({ ...prev, lot: v ?? undefined, page: undefined }),
              })
            }
          />

          <div className="flex shrink-0 items-center gap-2">
            <PlatformStockBulkDialog />
            <PlatformStockDeclarationDialog
              storeReference={storeReference}
              defaultProductReference={search || null}
            />
          </div>
        </div>

        <PlatformStockTable
          storeReference={storeReference}
          categoryIds={categoryIds}
          search={search}
          lot={lot}
          page={page}
          pageSize={pageSize}
          onNavigate={(params) => navigate({ search: (prev) => ({ ...prev, ...params }) })}
        />
      </AppContainer>
    </>
  )
}
